export enum ActionType {
  Create = 'create',
  Update = 'update',
}
